// extracted by mini-css-extract-plugin
export default {"backdrop":"loading_backdrop__nykaQ"};